import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "redux/store";
import environment from "environment";
import { OrganizationService } from "services/organization.service";
import { setOrganizationDetail } from "redux/authStateSlice";
import { brandingLogo } from "assets/images";
import { Shared } from "utility/shared";

export const BrandingLogo: React.FC<{
	isSBDForm?: boolean;
	className?: string;
}> = ({ isSBDForm = false, className = "" }) => {
	const dispatch = useDispatch();
	const organizationDetails = useSelector(
		(state: RootState) => state.authState.organizationDetails
	);
	const [logoUrl, setLogoUrl] = React.useState("");

	React.useEffect(() => {
		if (organizationDetails && organizationDetails.organizationLogo) {
			setLogoUrl(
				`${environment.blobStorageUrl}/${organizationDetails.filePath}/${organizationDetails.organizationLogo}`
			);
		}
	}, [organizationDetails]);

	React.useEffect(() => {
		const getBrandlingLogo = async () => {
			const tempOrgDetail = localStorage.getItem(
				Shared.localStorageKeys.organizationDetails
			);
			const parsedOrgDetail = tempOrgDetail ? JSON.parse(tempOrgDetail) : null;
			if (parsedOrgDetail && parsedOrgDetail.organizationLogo)
				setLogoUrl(
					`${environment.blobStorageUrl}/${parsedOrgDetail.filePath}/${parsedOrgDetail.organizationLogo}`
				);
			else
				try {
					const res =
						await OrganizationService.getOrganizationBrandingDetails(); // API call to fetch branding detail
					if (res)
						dispatch(
							setOrganizationDetail({
								...organizationDetails,
								filePath: res.filePath,
								organizationLogo: res.organizationLogo,
								name: res.name,
							})
						);
					else setLogoUrl(brandingLogo);
				} catch (error) {
					setLogoUrl(brandingLogo);
				}
		};
		getBrandlingLogo();
		return () => {
			setLogoUrl("");
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const style: React.CSSProperties = isSBDForm
		? {
				display: "block",
				width: "100%",
				height: "100%",
				maxHeight: "78px",
				maxWidth: "174px",
				objectFit: "contain",
		  }
		: {};

	return logoUrl ? (
		<img src={logoUrl} alt="LOGO" style={style} className={className} />
	) : (
		<></>
	);
};
